import { AxiosError } from 'axios';

import store from 'store/store';
import {
	setDeniedAccessErrorOpen,
	setQueueDelayNotificationOpen,
} from 'store/user-service/userSlice';

import { ChatGPTModels } from 'core/enums/common';

import { refreshAccessToken } from './API';
import { timeBeforeRequestRetry } from './ChatGPT.axios';
import { VaultService } from './storage';

const storage = new VaultService();

interface FetchOptions extends RequestInit {
	body: string;
	headers: Record<string, string>;
}

export const chatGptFetch = async (url: string, options: FetchOptions): Promise<any> => {
	try {
		const response = await fetch(url, options);

		if (!response.ok) {
			switch (response.status) {
				case 400:
					if (options.body) {
						const data = JSON.parse(options.body);

						if (data?.aiModelEnum) {
							data.aiModelEnum = ChatGPTModels['GPT4-turbo'];

							const newBody = {
								...data,
								aiModelEnum: ChatGPTModels['GPT4-turbo'],
							};
							const newOptions = {
								...options,
								body: JSON.stringify(newBody),
							};
							return chatGptFetch(url, newOptions);
						}
					}
					break;

				case 401:
					try {
						if (storage.getItem('token')) {
							await refreshAccessToken();

							return chatGptFetch(url, options);
						}
					} catch (refreshError) {
						const axiosError = refreshError as AxiosError;
						return Promise.reject(axiosError.response);
					}
					break;
				case 403:
					store.dispatch(setDeniedAccessErrorOpen(true));
					break;
				case 429:
					store.dispatch(setQueueDelayNotificationOpen(true));
					await new Promise((resolve) =>
						setTimeout(
							resolve,
							response.headers.get('retry-after')
								? (Number(response.headers.get('retry-after')) + 1) * 1000
								: timeBeforeRequestRetry
						)
					);
					return chatGptFetch(url, options);

				case 500:
					if (response) {
						const retryCount = Number(options.headers?.['retry-count'] || 0);

						if (retryCount >= 5) {
							return Promise.reject(response);
						}

						const failedRequest: FetchOptions = {
							...options,
							headers: {
								...options.headers,
								'retry-count': (retryCount + 1).toString(),
							},
						};

						return chatGptFetch(url, failedRequest);
					}
					return Promise.reject(response);

				default:
					return Promise.reject(response);
			}
		}

		return response;
	} catch (error) {
		return Promise.reject(error);
	}
};
